<template>
  <div class="flex flex-col items-center justify-center text-center p-6">
    <img :src="imgSrc" alt="Not Found" class="w-64 h-64 mb-6 object-contain" v-if="imgSrc" />

    <!-- Large heading like "Oops!" -->
    <h2 class="text-4xl font-bold text-gray-700 mb-2">
      {{ title }}
    </h2>

    <!-- Smaller message like "Page not found" -->
    <p class="text-gray-500 text-lg max-w-md">
      {{ message }}
    </p>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    default: 'Oops!',
  },
  message: {
    type: String,
    default: 'Something went wrong.',
  },
  imgSrc: {
    type: String,
    default: '',
  },
});
</script>
